import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link, useHistory } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import { Pagination, Input, Modal, Tooltip, Select } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, AddIcon2, SubcategoryIcon } from 'assets/icons';
import { IncomeService } from 'services';
import ModalCreate from './modal-create';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	category_id: ''
}

class Incomes extends React.Component<Props> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		form: INITIAL_STATE,
		visible: false,
		item: null,
		categories: [],
		type_id: Constants.CATEGORY_TYPES.INCOMES
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Ingresos y Gastos',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading = false, resetItemActive = true) => {
		const res: any = await IncomeService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			type_id: this.state.type_id
		});
		this.setState({
			data: res.subcategories?.rows || [],
			last_page: res.subcategories?.count || 1,
			categories: res.categories || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	setType = (type_id: number) => {
		this.setState({
			type_id,
			form: INITIAL_STATE,
			page: 1
		},() => this.load());
	}

	edit = (e: any, item: any) => {
		if (e) {
			e.preventDefault();
		}
		this.setState({
			visible: true,
			item
		});
	}

	delete = (e: any, item: any) => {
		if (e) {
			e.preventDefault();
		}
		Globals.confirm('¿Desea eliminar la subcategoría?',async () => {
			await IncomeService.admin.delete({
				subcategory_id: item.id
			});
			this.load(true);
		});
	}

	render() {
		const { visible, type_id, data } = this.state;

		return (
			<div id="admin-incomes">
				<Modal
		          className="modal-create-category"
		          visible={ visible }
		          title={ (this.state.item ? 'Editar' : 'Nueva') + ' subcategoría' }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	type_id={ this.state.type_id }
		            item={ this.state.item }
		            categories={ this.state.categories }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="flex-tabs">
					<div className="container-tabs">
						<button className={ `btn ${ type_id == Constants.CATEGORY_TYPES.INCOMES ? 'active' : '' }` } onClick={ () => this.setType(Constants.CATEGORY_TYPES.INCOMES) }>
							Ingresos
						</button>
						<button className={ `btn ${ type_id == Constants.CATEGORY_TYPES.EXPENSES ? 'active' : '' }` } onClick={ () => this.setType(Constants.CATEGORY_TYPES.EXPENSES) }>
							Gastos
						</button>
						<button className={ `btn ${ type_id == Constants.CATEGORY_TYPES.DEBTS ? 'active' : '' }` } onClick={ () => this.setType(Constants.CATEGORY_TYPES.DEBTS) }>
							Deudas
						</button>
					</div>
				</div>

				<div className="row row-filter">
					<div className="col-md-5" style={{ paddingLeft: '0px' }}>
						<Input
							value={ this.state.form.search }
							name="search"
							placeholder="Buscar"
							label="Buscar por nombre"
							className="input-table"
							onSubmit={ () => this.load() }
							onChange={ (e: any) => {
								clearTimeout(this.timer);
								this.timer = setTimeout(() => {
									this.load(true);
								},1000);
								this.change(e); 
							} } />
					</div>
					<div className="col-md-5" style={{ paddingLeft: '0px' }}>
						<Select
							color="white"
							placeholder="Seleccionar"
							label="Categoría"
							name="category_id"
							onChange={ (e: any) => this.change(e,async () => {
								this.load(true);
							}) }
							value={ this.state.form.category_id }
							options={ this.state.categories?.map((item: any) => {
								return {
									value: item.id,
									label: item.name
								}
							}) } />
					</div>
					<div className="col-md-2">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<div className="container-table">
					<div className="row">
						<div className="col-md-8">
							<h3>Subcategorías registradas</h3>
						</div>
						<div className="col-md-4 text-right">
							<button className="btn btn-add" onClick={ () => this.add() }>
								<img src={ AddIcon } />
								Nuevo
							</button>
						</div>
					</div>
					<hr />
					{
						data.map((item: any) => {
							return (
								<>
									<div className="item">
										{
											item?.image && (
												<div className="container-image">
													<img className="image" src={ Constants.BASE_STORAGE + item?.image } />
												</div>
											)
										}
										<div style={{ flex: 1 }}>
											<p className="name">{ item?.name }</p>
										</div>
										{
											checkPermission(Constants.MODULES.INCOMES,'write') && (
												<Tooltip title="Editar">
													<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,item) }>
														<img src={ EditIcon } />
													</a>
												</Tooltip>
											)
										}
										{
											checkPermission(Constants.MODULES.INCOMES,'delete') && (
												<Tooltip title="Eliminar">
													<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,item) }>
														<img src={ TrashIcon } />
													</a>
												</Tooltip>
											)
										}
									</div>
								</>
							)
						})
					}
					{
						data.length == 0 && (
							<p className="no-items">No se encontraron registros</p>
						)
					}
				</div>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Incomes);